export const ProcedenciasActionTypes = {
  API_RESPONSE_SUCCESS: '@@procedencias/API_RESPONSE_SUCCESS',
  API_RESPONSE_ERROR: '@@procedencias/API_RESPONSE_ERROR',

  GET_PROCEDENCIA: '@@procedencias/GET_PROCEDENCIA',
  LIST_PROCEDENCIAS: '@@procedencias/LIST_PROCEDENCIAS',
  ADD_PROCEDENCIA: '@@procedencias/ADD_PROCEDENCIA',
  UPDATE_PROCEDENCIA: '@@procedencias/UPDATE_PROCEDENCIA',
  DELETE_PROCEDENCIA: '@@procedencias/DELETE_PROCEDENCIA',
  SET_FILTER: '@@procedencias/SET_FILTER',

  RESET: '@@procedencias/RESET'
}
